import {
    FrontAgentConstants,
	EmberAgentConstants,
	FireConstants,
	setConstants,
	getFireConstantsWithOverrides,
	getFloatFromParams
} from '@firesim/simkit-core'
import { windInfluence, emberThrowWeight } from "./wind-influence";

// Legacy constants from original app.js (src/js/old/constants.js)
const baseFrontAgentConstants: FrontAgentConstants = {
  fuelLoadMultiplier: getFloatFromParams('fuelLoadMultiplier') || -0.039,
  fireDangerMultiplier: getFloatFromParams("fireDangerMultiplier") || 1.06,
  fireDangerAddition: getFloatFromParams("fireDangerAddition") || -0.7,
  surroundingMultiplier: getFloatFromParams("surroundingMultiplier") || 0.5,
  surroundingAddition: getFloatFromParams("surroundingAddition") || 0.9,
  burnChanceRange: getFloatFromParams("burnChanceRange") || 26,
  // spotChanceRange is used by the new model; legacy spot throws use calcThrowDistance.
  // Keep a sane default but it won’t affect DarwinFrontAgent.
  spotChanceRange: 45,
};

const baseEmberAgentConstants: EmberAgentConstants = {
  burnTimeMultiplier: getFloatFromParams("emberBurnTimeMultiplier") || 0.15,
  lifetime: getFloatFromParams("emberLifetime") || 60,
  randomRange: getFloatFromParams("emberRandomRange") || 55,
};

export const fireConstants: FireConstants = getFireConstantsWithOverrides({
    agents: {
        frontAgent: baseFrontAgentConstants,
        emberAgent: baseEmberAgentConstants
    },
    wind: {
        windInfluence,
        emberThrowWeight
    }
});

setConstants(fireConstants);

const agentConstants = fireConstants.agents;

export default agentConstants;

export const frontAgentConstants = fireConstants.agents.frontAgent;
export const emberAgentConstants = fireConstants.agents.emberAgent;
